require('./cardDeferredPurchasesView.scss');

// @vendor
const PropTypes = require('prop-types');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');

// @core
const { formatText } = require('core/i18n').i18n;

// @ utilities
const { cardConstants } = require('utilities/accessHelperConditions/cards');
const AccessHelper = require('utilities/accessHelper');

// @actions
const cardTransactionsDownloadActions = require('actions/cardTransactionsDownload');
const cardsTransactionsActions = require('actions/getCardsTransactions');
const signaturePatternActions = require('actions/signaturePattern');

// @components
const CardHeaderDetails = require('components/cards/cardHeaderDetails/cardHeaderDetails');
const CardLastMovements = require('components/cards/cardLastMovements/cardLastMovements');

// @ commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');


class CardDeferredPurchasesView extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    componentDidMount() {
        const { history, immCards, match: { params: { cardId } } } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);

        AccessHelper.allowAccess(cardConstants.CARD_MOVEMENTS, { immCard }, history);
    }

    componentWillUnmount() {
        this.props.clearFilters();
    }

    render() {
        const {
            match: { params: { cardId } },
            cardTransactionsOutdated,
            clearFilters,
            downloadCardsTransactions,
            immCards,
            immCardCharge,
            immProfile,
            immTransactions,
            requestCardDeferredTransactions,
            requestNextCardTransactionsPage,
            resetFilter,
            setTransactionsFilters,
            immCardsTransactionsDownload,
            validateAndExecuteSagas,
            flagBasedFeatures
        } = this.props;

        const immCard = immCards.get('byId').get(cardId);

        let block;
        if (immCard) {
            const breadcrumbTitle = formatText('cardDeferredPurchases-breadcrumbPageTitle');
            const mappingBreadcrumb = [
                {
                    text: formatText('breadcrumb-cards'),
                    url: '/myprofile/cards'
                },
                {
                    text: breadcrumbTitle,
                    url: ''
                }
            ];

            block = (
                <div>
                    <div className="container-fluid">
                        <div className="row">
                            <OKCover size="medium" section="cards" customClass="col-xs-12">
                                <OKHeaderSubPage
                                    breadcrumbConfig={mappingBreadcrumb}
                                    finalTitle={breadcrumbTitle}
                                >
                                    <div className="card-deferred-purchases__header-details">
                                        <CardHeaderDetails
                                            immCard={immCard}
                                            isFetching={immCardCharge.get('isFetching')}
                                        />
                                    </div>
                                </OKHeaderSubPage>
                            </OKCover>
                        </div>
                    </div>
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row grid-view--content-position-negative">
                                <div className="col-md-12">
                                    <CardLastMovements
                                        cardTransactionsOutdated={cardTransactionsOutdated}
                                        clearFilters={clearFilters}
                                        downloadCardsTransactions={downloadCardsTransactions}
                                        flagBasedFeatures={flagBasedFeatures}
                                        immCard={immCard}
                                        immCardsTransactionsDownload={immCardsTransactionsDownload}
                                        immCards={immCards}
                                        immFilters={immTransactions.get('filters')}
                                        immProfile={immProfile}
                                        immTransactions={immTransactions.get(cardId)}
                                        requestCardTransactions={requestCardDeferredTransactions}
                                        requestNextCardTransactionsPage={requestNextCardTransactionsPage}
                                        resetFilter={resetFilter}
                                        setTransactionsFilters={setTransactionsFilters}
                                        showCardsDropdown={true}
                                        validateAndExecuteSagas={validateAndExecuteSagas}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            block = <LoadingSection />;
        }

        return block;
    }
}

CardDeferredPurchasesView.propTypes = {
    cardTransactionsOutdated: PropTypes.func.isRequired,
    clearFilters: PropTypes.func.isRequired,
    downloadCardsTransactions: PropTypes.func.isRequired,
    flagBasedFeatures: PropTypes.object,
    history: PropTypes.object.isRequired,
    immCardCharge: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immCardsTransactionsDownload: PropTypes.func.isRequired,
    immProfile: PropTypes.object.isRequired,
    immTransactions: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    requestCardDeferredTransactions: PropTypes.func.isRequired,
    requestNextCardTransactionsPage: PropTypes.func.isRequired,
    resetFilter: PropTypes.func.isRequired,
    setTransactionsFilters: PropTypes.func.isRequired,
    validateAndExecuteSagas: PropTypes.func.isRequired,
};

module.exports.constructor = CardDeferredPurchasesView;
module.exports.CardDeferredPurchasesView = connect(
    state => ({
        flagBasedFeatures: state.flagBasedFeatures,
        immCards: state.cards,
        immCardCharge: state.cardCharge,
        immProfile: state.profile,
        immTransactions: state.cardsTransactions,
        immCardsTransactionsDownload: state.cardsTransactionsDownload
    }),
    {
        cardTransactionsOutdated: cardsTransactionsActions.cardTransactionsOutdated,
        clearFilters: cardsTransactionsActions.clearCardTransactionsFilters,
        downloadCardsTransactions: cardTransactionsDownloadActions.downloadCardsTransactions,
        requestCardDeferredTransactions: cardsTransactionsActions.requestCardDeferredTransactions,
        requestNextCardTransactionsPage: cardsTransactionsActions.requestNextCardTransactionsPage,
        resetFilter: cardsTransactionsActions.resetCardTransactionsFilter,
        setTransactionsFilters: cardsTransactionsActions.setTransactionsFilters,
        validateAndExecuteSagas: signaturePatternActions.validateAndExecuteSagas,
    }
)(withRouter(CardDeferredPurchasesView));
